"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutProperties"));
var React = _interopRequireWildcard(require("react"));
var _excluded = ["title", "titleId"];
var SvgIconWifi = function SvgIconWifi(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M11.905 3.553A15.317 15.317 0 0 0 1.04 8.049a.75.75 0 1 0 1.06 1.06c5.422-5.421 14.19-5.421 19.61 0a.751.751 0 1 0 1.061-1.06 15.32 15.32 0 0 0-10.866-4.496Zm0 4.46a10.872 10.872 0 0 0-7.712 3.19.75.75 0 1 0 1.06 1.06 9.396 9.396 0 0 1 13.305 0 .75.75 0 1 0 1.06-1.06 10.874 10.874 0 0 0-7.713-3.19Zm0 4.459a6.428 6.428 0 0 0-4.56 1.883.75.75 0 1 0 1.062 1.061 4.937 4.937 0 0 1 6.997 0 .748.748 0 0 0 1.236-.236.75.75 0 0 0-.175-.825 6.428 6.428 0 0 0-4.56-1.883ZM12 17a2 2 0 1 0 0 4 2 2 0 0 0 0-4Z"
  }));
};
var _default = SvgIconWifi;
exports.default = _default;